export type TableDataType = {
  v2_hardware: string;
  purpose: string;
  qty: number;
  software_version: string;
};

export const ACI_V2_HARDWARE_TABLE_DATA: TableDataType[] = [
  {
    v2_hardware: "N9K-C9364C",
    purpose: "SPINE",
    qty: 1,
    software_version: "5.2.3E Or Higher",
  },
  {
    v2_hardware: "N9K-C93180YC or N9k-C93120TX",
    purpose: "LEAF",
    qty: 2,
    software_version: "5.2.3E Or Higher",
  },
  {
    v2_hardware: "APIC-M1/M2",
    purpose: "APIC",
    qty: 1,
    software_version: "5.2.3E Or Higher",
  },
  {
    v2_hardware: "UCS-C220/240",
    purpose: "VMM integration with Vmware or Hyper V",
    qty: 1,
    software_version: "ESX6.7 or  Win Server 2019",
  },
  {
    v2_hardware: "Catalyst 3750-X",
    purpose: "L2-L3 Switch",
    qty: 1,
    software_version: "15.5",
  },
];
